"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var carDetailsStyles_1 = require("./carDetailsStyles");
var SectionExtender_1 = require("../../sectionExtender/SectionExtender");
var CarImage_1 = require("../CarImage/CarImage");
var CarDetailsPrices_1 = require("../CarDetailsPrices/CarDetailsPrices");
var Translation_1 = require("../../../../common/components/presentation/Translation/Translation");
var CarImageWithBg_1 = require("../CarImage/CarImageWithBg");
var CarTitle_1 = require("../CarTitle/CarTitle");
var CarDetails = function (_a) {
    var modelTitle = _a.modelTitle, variantTitle = _a.variantTitle, imageSrc = _a.imageSrc, _b = _a.prices, primaryTotal = _b.primaryTotal, secondaryTotal = _b.secondaryTotal, isMultiCurrency = _b.isMultiCurrency, financeDetails = _a.financeDetails, shouldRenderTitleInfo = _a.shouldRenderTitleInfo, isExtendable = _a.isExtendable, isExtended = _a.isExtended, toggleCarSection = _a.toggleCarSection, backgroundImg = _a.backgroundImg, interiorImg = _a.interiorImg, isBackgroundDefault = _a.isBackgroundDefault;
    var style = carDetailsStyles_1.default();
    var isFromAltSpc = core_1.useTheme().checkoutLite.isFromAltSpc;
    return (<core_1.Box className={style.carDetailsWrapper} data-test="summary:container:car_details">
      <core_1.Box className={style.carTitleImageContainer}>
        {isFromAltSpc ? (<>
            <CarImageWithBg_1.default isBackgroundDefault={isBackgroundDefault} imageSrc={imageSrc} interiorImg={interiorImg} backgroundImg={backgroundImg}/>
            <core_1.Grid container className={style.modelTitle}>
              <CarTitle_1.default shouldRenderTitleInfo={shouldRenderTitleInfo} modelTitle={modelTitle} variantTitle={variantTitle}/>
            </core_1.Grid>
          </>) : (<>
            <CarTitle_1.default shouldRenderTitleInfo={shouldRenderTitleInfo} modelTitle={modelTitle} variantTitle={variantTitle}/>
            <CarImage_1.default imageSrc={imageSrc}/>
          </>)}
      </core_1.Box>
      <CarDetailsPrices_1.default primary={primaryTotal} secondary={secondaryTotal} isMultiCurrency={isMultiCurrency} financeDetails={financeDetails}/>
      {isExtendable && (<SectionExtender_1.default text={<Translation_1.default id={"carDetails.label." + (isExtended ? 'hideDetails' : 'viewDetails')}/>} onClick={toggleCarSection} isSectionExtended={isExtended} data-test="summary:button:section_extender"/>)}
    </core_1.Box>);
};
exports.default = CarDetails;
